import { Component, OnInit } from '@angular/core';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { JobService } from 'src/app/services/job.service';
import { MatchingService } from 'src/app/services/matching.service';
import { MetadataService } from 'src/app/services/metadata.service';
import { YektanetService } from 'src/app/services/yektanet.service';
import { JobtitleService } from 'src/app/services/jobtitle.service';
import { UserSortType, UserCriteria, MetadataType } from 'src/app/common';
import { Utility } from 'src/app/core/common';

@Component({
  selector: 'app-job-booster',
  templateUrl: './job-booster.component.html',
  styleUrls: ['./job-booster.component.scss']
})
export class JobBoosterComponent implements OnInit {
  UserSortType = UserSortType;
  alerts: any[];
  najvaSetting: any;
  najvaSegments: any[];
  showAlerts = false;
  constructor(private userService: UserService, private jobService: JobService, private route: ActivatedRoute,
    private spinner: SpinnerService, private toastr: ToastrService, private matchingService: MatchingService,
    private metadataService: MetadataService, private jobTitleService: JobtitleService, private yektanetService: YektanetService) { }

  get promoted() { return this.payload.Criteria.Seeker.Promoted; }
  set promoted(value: boolean) { this.payload.Criteria.Seeker.Promoted = value ? true : null; }

  get resend() { return this.payload.Resend; }
  set resend(value: boolean) { this.payload.Resend = value; }

  get verifiedEmail() { return this.payload.Criteria.Seeker.VerifiedEmail; }
  set verifiedEmail(value: boolean) { this.payload.Criteria.Seeker.VerifiedEmail = value ? true : null; }
  now = new Date();

  job: any;
  seekers: any[];
  searchCounts: any = {};
  sentCount: any = {};
  sendCount: any = {};
  fields: string[];
  view = {
    jobTitle_new: true,
    jobTitles: false,
    fields: false,
    subscribes: false,
    najva: true
  };

  payload = {
    NajvaSegments: [],
    Criteria: <UserCriteria>{
      UseQueryString: true,
      Seeker: {
        VerifiedEmail: null,

        Gender: -1,
        LastUpdateFrom: new Date(this.now.getTime() - 10 * 365 * 24 * 60 * 60 * 1000), // Last 10 years
        JobAlert: {
          //LastAlertDateTo: new Date(this.now.getTime()),
          Keyword: null
        },
        Degrees: [],
        Fields: []
      },
      Sort: UserSortType.AlertMatching
    },
    JobTitles_New: [],
    JobCode: null,
    From: 0,
    Limit: 20,
    SendCount: 0,
    SendHour: 11,
    Resend: false
  };

  async ngOnInit() {
    await new Promise<void>(resolve => {
      this.route.params.subscribe(async params => {
        this.payload.JobCode = params['code'];
        if (this.payload.JobCode) {
          await this.loadJob();
          await this.getSentCount();
          await this.loadNajva();
        }
        resolve();
      });
    });
    this.fields = await this.userService.educationFields();
    this.jobTitles = await this.metadataService.search({ Types: [MetadataType.JobTitle] });
    this.jobTitles_new = await this.jobTitleService.adminSearch({ UseForAlert: true });
  }
  async loadNajva() {
    this.spinner.show();
    this.najvaSetting = await this.yektanetService.getNajvaSetting();
    this.setNajvaSegments();
    this.spinner.hide();
  }
  private setNajvaSegments() {
    this.najvaSegments = this.najvaSetting.Accounts.map(_ => _.Segments).flat();
  }

  async fetchNajvaSegments() {
    this.spinner.show();
    this.najvaSetting = await this.yektanetService.fetchNajvaSegments();
    this.setNajvaSegments();
    this.spinner.hide();
  }

  jobTitles: any[];
  jobTitles_new: any[];

  async loadJob() {
    this.job = await this.jobService.getByCode(this.payload.JobCode);
  }

  async getSentCount() {
    this.spinner.show();
    this.sentCount = await this.matchingService.alertCount(this.job.Id);
    this.alerts = await this.matchingService.alertReport(this.job.Id);
    this.toastr.success('گزارش ارسال دریافت شد');
    this.spinner.hide();
  }

  async search(searchType: string) {
    this.spinner.show();
    let pl: any = this.getPayload(searchType);

    // payload.From = page.from;
    // payload.Limit = page.limit;
    this.searchCounts = Object.assign(this.searchCounts, await this.matchingService.getSearchCounts(pl));


    this.spinner.hide();
  }

  private getPayload(searchType: string) {
    let pl: any = Utility.clone(this.payload);
    pl.SearchType = searchType;

    switch (searchType) {
      case 'jobTitle':
        pl.Criteria.Seeker.Fields = undefined;
        pl.Criteria.Seeker.JobAlert.Keyword = undefined;
        pl.JobTitles_New = undefined;
        break;
      case 'field':
        pl.Criteria.Seeker.JobTitles = undefined;
        pl.Criteria.Seeker.JobAlert.Keyword = undefined;
        pl.JobTitles_New = undefined;
        break;
      case 'subscribe':
        pl.Criteria.Seeker.Fields = undefined;
        pl.Criteria.Seeker.JobTitles = undefined;
        pl.Criteria.Seeker.Keyword = undefined;
        pl.Criteria.Seeker.HasCode = null;
        pl.Criteria.Seeker.IncludeJobAlertLocation = true;
        pl.JobTitles_New = undefined;
        break;
      case 'jobTitle_new':
        pl.Criteria.Seeker.Fields = undefined;
        pl.Criteria.Seeker.JobTitles = undefined;
        pl.Criteria.Seeker.JobAlert.Keyword = undefined;
        break;
      case 'najva':
        pl.JobTitles_New = undefined;
        pl.Criteria.Seeker = undefined;
      default:
        break;
    }
    return pl;
  }

  async send(searchType: string, channel: string, sendCount: number) {
    this.spinner.show();
    let pl: any = this.getPayload(searchType);
    pl.Channel = channel;
    pl.SendCount = +sendCount;

    await this.matchingService.sendAlert(pl);
    this.spinner.hide();

    this.getSentCount();
  }

  async deleteJobAlert(alert) {
    this.spinner.show();
    await this.matchingService.deleteAlert(alert.Id);
    this.alerts = await this.matchingService.alertReport(this.job.Id);
    this.spinner.hide();

  }

  async showSeekers(alert) {
    this.seekers = [];
    if (!alert.Users || !alert.Users.length)
      return;

    this.seekers = await this.userService.adminGetByIds(alert.Users.map(_ => _.UserId));

  }

}
